module.exports = __webpack_public_path__ + "static/media/img-feature-curation-200@2x.af2fe6ab.png";